<div class="pt-shop-order__products">
  <ng-content/>

  @for (product of order()?.products; track product.id) {
    <div class="pt-shop-order__product">
      @if (product?.saleImage?.url) {
        <img
          class="pt-shop-order__product-discount-label"
          [src]="product.saleImage.url"
          [alt]="product.saleImage.name"
        />
      }
      <img
        class="pt-shop-order__product-img"
        ptImageLoader
        [src]="product.mainImage.url"
        [alt]="product.mainImage.name"
        [routerLink]="[shopSegment, order().location.id, 'product', product.productGlobalId]"
      />

      <div class="pt-shop-order__product-body">
        <div class="pt-shop-order__product-name-options">
          <h2
            class="pt-shop-order__product-name"
            [routerLink]="[shopSegment, order().location.id, 'product', product.productGlobalId]"
          >
            {{ product.name }}
          </h2>

          <div class="pt-shop-order__product-options">
            @if (product.productOption.optionSize) {
              <div class="pt-shop-order__product-option">
                <div class="pt-shop-order__product-option-label">
                  {{ 'shopOrder.product.options.label.size' | translate }}
                </div>

                <div class="pt-shop-order__product-option-value">
                  {{ product.productOption.optionSize.size }}
                </div>
              </div>
            }

            @if (product.productOption.optionColor) {
              <div class="pt-shop-order__product-option">
                <div class="pt-shop-order__product-option-label">
                  {{ 'shopOrder.product.options.label.color' | translate }}
                </div>

                <div
                  class="pt-shop-order__product-option-color"
                  [style.background-color]="product.productOption.optionColor.color"
                >
                </div>
              </div>
            }
          </div>
        </div>
        <div
          class="pt-shop-order__product-price"
          [class.sale]="product.oldPrice"
        >
          @if (product.oldPrice) {
            <span class="pt-shop-order__product-price-old">{{ product.oldPrice }}</span>
          }
          {{ product.price }}
          <pt-coin size="24"/>
        </div>
      </div>

      <div class="pt-shop-order__product-controls">
        <div class="pt-shop-order__product-quantity">
          <pu-increment
            [ngModel]="product.quantity"
            (ngModelChange)="changeQuantity(product, $event)"
            [isReadonly]="true"
            [min]="minQuantity"
            [class.ng-invalid]="isInvalidQuantity(product)"
          />

          @if (isInvalidQuantity(product)) {
            <p class="pt-shop-order__product-stock-error">
              @if (stocks()[product.productOption.id] === 0) {
                <span translate>
                  shopOrder.product.stockError.unavailableProduct
                </span>
              } @else {
                <span
                  translate
                  [translateParams]="{ stock: stocks()[product.productOption.id] }"
                >
                  shopOrder.product.stockError.notEnoughQuantity
                </span>
              }
            </p>
          }
        </div>

        <button
          type="button"
          puButton
          size="m"
          uiType="quaternary"
          (click)="removeProduct.emit(product)"
        >
          <pu-icon
            iconName="trash"
            size="20"
          />
          {{ 'shopOrder.product.controls.remove' | translate }}
        </button>
      </div>
    </div>
  }

  @if (order()?.products.length > 1) {
    <div class="pt-shop-order__products-footer">
      <button
        type="button"
        puButton
        size="m"
        uiType="quaternary"
        (click)="removeAllProducts.emit()"
      >
        <pu-icon
          iconName="trash"
          size="20"
        />
        {{ 'shopOrder.header.controls.removeAllItems' | translate }}
      </button>
    </div>
  }
</div>

<div class="pt-shop-order__delivery-form">
  <div class="pt-shop-order__divider"></div>

  @if (order()) {
    <div class="pt-shop-order__total">
      {{ 'shopOrder.total.title' | translate }}

      <div class="pt-shop-order__total-price">
        {{ order().total }}
        <pt-coin size="24"/>
      </div>
    </div>

    <pt-delivery-form
      [user]="user()"
      [order]="order()"
      [pickupLocations]="pickupLocations()"
      [cancelLink]="cancelLink()"
      [cancelName]="cancelName()"
      (locationChanged)="locationChanged.emit($event)"
      (saveOrder)="saveOrder.emit($event)"
    />
  } @else {
    <a
      class="pt-shop-order__btn-cancel md:pu-button_l"
      puButton
      uiType="secondary"
      size="m"
      [routerLink]="cancelLink()"
    >
      {{ cancelName() }}
    </a>
  }
</div>
